/**
 * Rivo Points Integration
 * Polls for Rivo potential points element and replaces sentinel text in product callouts
 */

;(function () {
  'use strict'

  const SENTINEL_TEXT = '[potential_points]'
  const POINTS_SELECTOR = '.order-placed-potential-points-amount'
  const CALLOUTS_SELECTOR = '.product__callouts-item-text p'
  const POLL_INTERVAL = 200 // Poll every 200ms
  const MAX_POLL_ATTEMPTS = 30 // Stop polling after 6 seconds

  let pollAttempts = 0
  let pollInterval
  let mutationObserver
  let elementsWithSentinel = []

  /**
   * Find and store all elements containing the sentinel text
   */
  function findElementsWithSentinel() {
    const calloutElements = document.querySelectorAll(CALLOUTS_SELECTOR)
    elementsWithSentinel = []

    calloutElements.forEach((element) => {
      if (element.textContent.includes(SENTINEL_TEXT)) {
        // Store original text and element reference
        elementsWithSentinel.push({
          element: element,
          originalText: element.textContent,
        })
      }
    })

    return elementsWithSentinel.length > 0
  }

  /**
   * Replace sentinel text with points value in all stored elements
   */
  function replaceSentinelText(pointsValue) {
    elementsWithSentinel.forEach((item) => {
      // Always use the original text to avoid multiple replacements
      // Use replaceAll to avoid regex issues with square brackets
      const newText = item.originalText.replaceAll(SENTINEL_TEXT, pointsValue)
      item.element.textContent = newText
    })
  }

  /**
   * Set up mutation observer to watch for changes in the points element
   */
  function setupMutationObserver(pointsElement) {
    if (mutationObserver) {
      mutationObserver.disconnect()
    }

    mutationObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type === 'childList' || mutation.type === 'characterData') {
          const newPointsValue = pointsElement.textContent.trim()
          if (newPointsValue) {
            replaceSentinelText(newPointsValue)
          }
        }
      })
    })

    // Observe changes to the points element and its children
    mutationObserver.observe(pointsElement, {
      childList: true,
      subtree: true,
      characterData: true,
    })
  }

  /**
   * Initialize the integration once points element is found
   */
  function initializeIntegration(pointsElement) {
    const pointsValue = pointsElement.textContent.trim()

    if (!pointsValue) {
      console.warn('Rivo points element found but has no content')
      return
    }

    // Find elements with sentinel text
    const foundSentinels = findElementsWithSentinel()

    if (!foundSentinels) {
      console.log('No product callouts with [potential_points] sentinel found')
      return
    }

    // Replace sentinel text with points value
    replaceSentinelText(pointsValue)

    // Hide the original Rivo points element
    const loyaltyPointsElement = document.querySelector('#loy-potential-points')
    if (loyaltyPointsElement) {
      loyaltyPointsElement.style.display = 'none'
    }

    // Set up mutation observer
    setupMutationObserver(pointsElement)

    console.log(
      `Rivo integration initialized: replaced ${elementsWithSentinel.length} instances of ${SENTINEL_TEXT} with "${pointsValue}"`
    )
  }

  /**
   * Poll for the points element
   */
  function pollForPointsElement() {
    const pointsElement = document.querySelector(POINTS_SELECTOR)

    if (pointsElement) {
      clearInterval(pollInterval)
      initializeIntegration(pointsElement)
      return
    }

    pollAttempts++

    if (pollAttempts >= MAX_POLL_ATTEMPTS) {
      clearInterval(pollInterval)
      console.log('Rivo points element not found after maximum polling attempts')
    }
  }

  /**
   * Start polling when DOM is ready
   */
  function startPolling() {
    // Check immediately if DOM is already loaded
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        pollInterval = setInterval(pollForPointsElement, POLL_INTERVAL)
        pollForPointsElement() // Check immediately
      })
    } else {
      pollInterval = setInterval(pollForPointsElement, POLL_INTERVAL)
      pollForPointsElement() // Check immediately
    }
  }

  /**
   * Cleanup function
   */
  function cleanup() {
    if (pollInterval) {
      clearInterval(pollInterval)
    }
    if (mutationObserver) {
      mutationObserver.disconnect()
    }
  }

  // Handle page unload
  window.addEventListener('beforeunload', cleanup)

  // Start the integration
  startPolling()
})()
